import React from "react";
import {
  Menu,
  MenuProps,
  MenuItem,
  Button,
  Divider,
  useTheme,
  Box,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ExerciseTagDto } from "@growth-machine-llc/stridist-api-client";
import TagChip from "./tags/TagChip";
import { exerciseTagCategoryMultiSelectStyles } from "./exerciseLibraryStyles";

const useStyles = makeStyles((theme) => ({
  tag: {
    padding: theme.spacing(0.5, 1.5),
    height: 22,
    "& > *": {
      fontSize: 14,
    },
    alignItems: "center",
  },
}));

export interface ExerciseSelectedTagsProps
  extends Omit<MenuProps, "open" | "onClose"> {
  onClose: () => void;
  anchorEl?: HTMLElement | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedTags?: ExerciseTagDto[];
  readonly?: boolean;
}

export function ExerciseSelectedTags(props: ExerciseSelectedTagsProps) {
  const s = useStyles();
  const classes = exerciseTagCategoryMultiSelectStyles();
  const { open, setOpen, anchorEl, selectedTags = [] } = props;

  const handleClose = () => {
    setOpen?.(false);
  };

  return (
    <>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: 300,
              maxHeight: 250,
            },
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        className={classes.menu}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {[
          <MenuItem key="header" className={classes.menuHeader}>
            Exercise tags
          </MenuItem>,
          <Divider key="divider-0" />,
          ...selectedTags.flatMap((tag, idx) => [
            <Box key={`box-${tag.id}`} className={classes.tagOption}>
              <Box>
                <TagChip
                  primaryColor={tag.primaryColor}
                  className={s.tag}
                  text={tag.title}
                />
                <Typography className={classes.tagDescription}>
                  {tag.description}
                </Typography>
              </Box>
            </Box>,
            <Divider key={`divider-${idx + 1}`} />,
          ]),
        ]}
      </Menu>
    </>
  );
}
